module.exports = __webpack_public_path__ + "static/media/cozy9149.63c6a091.jpg";